import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { CommonService } from "../../core/service/common-service/common.service";
import { DatePipe } from "@angular/common";
import { interval } from "rxjs";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TimepickerRef } from "ngx-material-timepicker/src/app/material-timepicker/models/timepicker-ref.interface";
import * as _moment from 'moment';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { SaveCallRecordingParams } from "src/app/model/save-call-recording-params.model";

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'LL',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: "app-soft-calling-dialog",
  templateUrl: "./soft-calling-dialog.component.html",
  styleUrls: ["./soft-calling-dialog.component.scss"],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
})
export class SoftCallingDialogComponent implements OnInit {
  @Input() vinNoList: any[];
  @Input() serviceDetails: any;
  @Input() selectedVin: string;
  @Input() customerNumber: string;
  @Input() isCustomerNumber: string;
  @Input() primaryNumber: string;
  @Input() callTypeSq: any;
  @Input() selectedWorkShop: string;
  @Input() amcNewOffering: string;
  @Input() amcRenewal: string;
  @Input() insuranceRenewal: string;
  @Input() extendedWarranty: string;
  @Input() phoneNo: string;
  @Input() cusType: string;
  @Input() custNameForSave: string;

 // @Input() bookingCount: number;
 // @Input() followupCount: number;
  @Output() close: EventEmitter<any> = new EventEmitter();
  userRoles: string;
  userRoleId: string;

  constructor(
    private datePipe: DatePipe,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  startTime: any;
  serviceDueDate: any;
  talked: string = "";
  creRemark: string;
  yesResponce: string = "";
  noResponce: string = "";
  customerId: string;
  userID: string;
  workShops = <any>[];
  //selectedWorkShop: string;
  today: Date = new Date();
  spinner: boolean;
  vinNoListArray: string[] = [];
  defaultVin: string;
  responseDropDownData: any;
  level1info = [];
  level1Form: FormGroup;
  level2info = [];
  level2Form: FormGroup;
  level3info = [];
  level3Form: FormGroup;
  level4info = [];
  level4Form: FormGroup;
  level5info = [];
  level5Form: FormGroup;
  callTypeMap = new Map();
  serviceInfo: any;
  submitted: boolean = false;
  formSubmitted: boolean = false;
  showNoRespError: boolean = false;
  milage: any;
  odometerEntry: any;
  bookingandResheduleMaxDate: Date = new Date();
  followupandCancleMaxDate: Date = new Date();
  showRemarkError: boolean = false;
  userInfo:any;
  customerData:any;

  @Input("timepicker")
  timePicker: TimepickerRef;

  ngOnInit() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || null)[0];
    this.customerData = JSON.parse(localStorage.getItem("customerData") || null);
    if (
      localStorage.getItem("userId") == null ||
      localStorage.getItem("userId") == undefined
    ) {
      this.router.navigate(["login"]);
    }
    this.userRoles = localStorage.getItem('userRoles');
    this.userRoleId = JSON.parse(localStorage.getItem("userInfo"))[0].roleId;
    this.customerId = localStorage.getItem("customerId");
    this.userID = localStorage.getItem("userId");
    this.workShops = JSON.parse(localStorage.getItem('workshops'));
    //this.selectedWorkShop = (this.workShops && this.workShops.length) ? this.workShops[0].workshopCode : '';
    this.serviceInfo = JSON.parse(localStorage.getItem("serviceInfo"));
    this.serviceDueDate = this.datePipe.transform(
      localStorage.getItem("serviceDueDate"),
      "yyyy-MM-dd"
    );
    this.startTime = new Date();
    this.callTypeMap.set("Service", 4);
    this.callTypeMap.set("Reminder", 2);
    this.callTypeMap.set("Visit", 1);
    this.callTypeMap.set("No Show", 3);
    this.odometerEntry = parseInt(localStorage.getItem("milage")) || 0;

    this.setVinList(this.selectedVin, false);
    this.bookingandResheduleMaxDate.setDate(this.bookingandResheduleMaxDate.getDate() + 15);
    this.followupandCancleMaxDate.setDate(this.followupandCancleMaxDate.getDate() + 15);
  }

  /**
   * Name: closeDailog
   * purpose: To close Dailog
   */
  closeDailog(): void {
    this.close.emit(null);
  }

  /**
   * Name: setVinList
   * purpose: To set Vin List
   */
  setVinList(defaultVin: any, vehicleChange: boolean): void {
    var vinListStr = Object.values(this.vinNoList);
    vinListStr.forEach(vin => {
      if (vin == defaultVin) {
        this.defaultVin = vin;
      }
    });
    for (let i = 0; i < vinListStr.length; i++) {
      this.vinNoListArray.push(vinListStr[i]);
    }
    if (vehicleChange) {
      this.serviceDetails = this.serviceInfo[defaultVin];
      this.callStatus("101");
    }
  }

  /**
   * Name: callStatus
   * purpose: To check call status
   * @param {string} status - call status
   */
  callStatus(status: string): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    if ("101" == status) {
      this.talked = "101";
      this.noResponce = "";
      const self = this;
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      //let callType = this.callTypeMap.get(this.serviceInfo[this.defaultVin].callType)
      this.commonService.getAMCDropdownData(4).subscribe(res => {
        if (res["responseCode"] == 0) {
          let data = res["responseData"];
          self.responseDropDownData = data;
          this.createLevel1Form(data["Level1"]);
        }
      }, error => {
        this.toastr.error(error, "Error");
        this.spinner = false;
      });
    } else {
      this.talked = "102";
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      this.yesResponce = "";
    }
  }

  /**
   * Name: createLevel1Form
   * purpose: To create Level1 Form
   * @param {any} data - form data
   */
  createLevel1Form(data: any): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    const formDataObj = {};
    for (const prop of data) {
      formDataObj[prop.label] = new FormControl("", [Validators.required]);
      if (prop.dataType == "Dropdown") {
        var dropDownData = [];
        prop.data.forEach((element) => {
          dropDownData.push({ value: element.key, viewValue: element.value });
        });
      }
      this.level1info.push({
        label: prop.label,
        type: prop.dataType,
        data: prop.dataType === "Dropdown" ? dropDownData : prop.data
      });
    }
    this.level1Form = new FormGroup(formDataObj);
  }

  /**
   * Name: createLevel2Form
   * purpose: To create Level2 Form
   * @param {any} data - form data
   */
  createLevel2Form(data: any): void {
    this.formSubmitted = false;
    this.showRemarkError = false;
    this.level2Form = undefined;
    this.level2info = [];
    const formDataObj = {};
    let selection = this.level1Form.controls["Select Reason"].value;
    if (data[selection] && data[selection].length) {
      for (const prop of data[selection]) {
         if (prop.dataType == "Date") {
          formDataObj[prop.data[0].key] = new FormControl("", [Validators.required]);
        } else if (prop.dataType == "Number") {
          formDataObj[prop.data[0].key] = new FormControl("", [Validators.minLength(10), Validators.maxLength(10)]);
        } else if (prop.dataType == "Time") {
          formDataObj[prop.data[0].key] = new FormControl("");
        } else {
          formDataObj[prop.data[0].key] = new FormControl("");
        }
        this.level2info.push({
          label: prop.label,
          type: prop.dataType,
          data: prop.data
        });
      }
    }
    this.level2Form = new FormGroup(formDataObj);
  }

  /**
  * Name: hasDataError
  * purpose: To check if customer form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasDataError(control: any, form: any): boolean {
    let controler = form.controls[control];
    return (
      controler &&
      (this.formSubmitted || controler.touched || controler.dirty) &&
      !controler.valid
    );
  }

  /**
   * Name: isSaveEnable
   * purpose: To check if save is unable
   */
  isSaveEnable() {
    if (
      this.noResponce != "" ||
      this.yesResponce == "Follow-up"
    ) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Name: createLevelWiseData
   * purpose: To create LevelWise Data
   */
  createLevelWiseData() {
    let date1 = "";
    var levelResponseData = {};

    if (this.level1Form !== undefined) {
      let obj = {};
      Object.keys(this.level1Form.value).filter(data => {
        obj[this.level1Form.value[data]] = this.level1Form.value[data];
      });
      levelResponseData["Level1"] = obj;
    } else {
      levelResponseData["Level1"] = null;
    }

    if (this.level2Form !== undefined) {
      let selectedDateTime = this.level2Form.value[304];
      // if (this.level2Form.value[302] != null) {
      //   this.level2Form.value[302] = this.datePipe.transform(
      //     this.level2Form.value[302],
      //     "yyyy-MM-dd"
      //   );
      // }

      if (this.level2Form.value[304] != null) {
        this.level2Form.value[304] = this.datePipe.transform(
          this.level2Form.value[304],
          "yyyy-MM-dd"
        );
      }

      // if (this.level2Form.value[302] != null) {
      //   date1 = this.level2Form.value[302];
      // } else
       if (this.level2Form.value[304] != null) {
        date1 = this.level2Form.value[304];
      }

      if (this.level2Form.value[303] != null || selectedDateTime) {
        this.level2Form.value[303] = selectedDateTime;
        this.level2Form.value[303] = this.datePipe.transform(this.level2Form.value[303], "yyyy-MM-ddTHH:mm:ssZ");
      }

      // if (this.level2Form.value[301] != null) {
      //   this.level2Form.value[301] = this.level2Form.value[301];
      // }

      let level2formValues = Object.assign({}, this.level2Form.value);
      levelResponseData["Level2"] = level2formValues;
    } else {
      levelResponseData["Level2"] = null;
    }
    return levelResponseData;
  }

  /**
   * Name: removeSavedVin
   * purpose: To remove Saved Vin
   */
  removeSavedVin(): void {
    const index: number = this.vinNoListArray.indexOf(this.defaultVin);
    if (index !== -1) {
      this.vinNoListArray.splice(index, 1);
    }
    if (this.vinNoListArray.length == 0) {
      this.closeDailog();
      //this.router.navigate(["soft-calling"]);
    } else {
      this.defaultVin = this.vinNoListArray[0];
      this.serviceDetails = this.serviceInfo[this.defaultVin];
      this.level1Form = undefined;
      this.level1info = [];
      this.level2Form = undefined;
      this.level2info = [];
      this.creRemark = null;
      this.submitted = false;
      this.showRemarkError = false;
      this.createLevel1Form(this.responseDropDownData["Level1"]);
    }
    this.router.navigate(["soft-calling"]);
  }

  checkFormValidation(): boolean {
    let valid = true;
    if (this.talked == "102" && this.noResponce == "") {
      valid = false;
    } else if (this.level1Form !== undefined && !this.level1Form.valid) {
      valid = false;
    } else if (this.level2Form !== undefined && !this.level2Form.valid) {
      valid = false;
    }
    if ((!this.creRemark && this.noResponce == "209")) {
      this.showRemarkError = true;
      valid = false;
    }
    this.submitted = valid;
    return valid;
  }

  /**
   * Name: saveDialData
   * purpose: To save Dial Data
   */
  saveDialData(): void {
    this.submitted = true;
    this.formSubmitted = true;
    if (this.checkFormValidation()) {
      this.showNoRespError = false;
      this.showRemarkError = false;
      var levelData = this.createLevelWiseData();
      this.spinner = true;
      let callTypeSeq = this.callTypeSq;
      let endTime = new Date();
      endTime.setSeconds(endTime.getSeconds() + 5);
      let request = {
        customerId: this.customerId,
        vin: this.defaultVin,
        callTypeSeq: callTypeSeq || "",
        callStartTime: this.startTime,
        callEndTime: endTime,
        customerContactInd: this.talked,
        responseForNo: this.noResponce || "",
        workShop: this.selectedWorkShop,
        levelData: levelData,
        remark: this.creRemark || "",
        userId: this.userID,
        amcNewOffering: this.amcNewOffering,
        amcRenewal: this.amcRenewal,
        insuranceRenewal: this.insuranceRenewal,
        extendedWarranty: this.extendedWarranty,
        customerType: this.cusType,
        phoneNo: this.phoneNo,
        customerName: this.custNameForSave,
        role:this.userRoles,
        userRoleId: this.userRoleId
      };
      this.saveCallRecording(request);
      this.spinner = false;
    } else if (this.talked == "102" && this.noResponce == "") {
      this.showNoRespError = true;
    }
  }

  

  private saveCallRecording(data:any){
    const URI = localStorage.getItem('exotel_URI')
    const CRE_ID = this.userInfo.userId 
    const CUSTOMER_CODE = this.customerData.customerId
    const SOURCE = "AMC";
    console.log("SAVE" , URI);
    if (URI)
      {
        this.spinner = true;
     
        const callRecordingParams = new SaveCallRecordingParams(CRE_ID,CUSTOMER_CODE,SOURCE,URI)
        this.commonService.saveCallRecording_API(callRecordingParams).subscribe({
          next:(response)=>{
            if (response.responseCode == 0) {
              this.toastr.success(response.message, 'Success')
              this.saveFormResponse(data);
            }
            else
            {
              this.toastr.error(response.message, 'Error');
              this.submitted = false;
            }
            
          }
          ,error:(error)=>{
            console.log(error);
            this.submitted = false;
            this.spinner = false;
          },
          complete:()=>{
            this.spinner = false;
            
            
          }
        })
      }else{
        this.saveFormResponse(data);
      }
  }

  private saveFormResponse(custResData: any){

    this.commonService.amcSaveData(custResData).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.submitted = false;
          this.toastr.info(res["message"], "Success");
          if (this.talked == "101") {
            this.removeSavedVin();
          } else {
            this.closeDailog();
            this.router.navigate(["soft-calling"]);
          }
          this.formSubmitted = false;
        } else {
          this.submitted = false;
          this.formSubmitted = false;
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      error => {
        this.submitted = false;
        this.formSubmitted = false;
        this.toastr.error(error, "Error");
        this.spinner = false;
      }
    );
  }
}